import { RADashboardLayout } from "@/interfaces/raDashboard.interface"
import { RADashboardPortfolioType } from "../asset-enums"
import { RADashboardCardId } from "../cards-enums"
import { RADashboardTabId } from "../tab-enums"

export const DefaultMasterDashboardLayout: RADashboardLayout = {
  "suggestedPortfolioType": [RADashboardPortfolioType.FixedIncome],
  "tabsOrder": [RADashboardTabId.Overview, RADashboardTabId.FactorLens, RADashboardTabId.Holdings],
  "initialTab": RADashboardTabId.Overview,
  "tabLayouts": {
    [RADashboardTabId.Overview]: {
      cardsOrder: [
        RADashboardCardId.Point_Beta,
        RADashboardCardId.MetricsSummaryRisk,
        RADashboardCardId.Point_TrailingRisk,
        RADashboardCardId.Point_DV01,
        RADashboardCardId.Point_SpreadDuration,
      ],
    },
    [RADashboardTabId.FactorLens]: {
      "cardsOrder": [
        RADashboardCardId.FactorLensGridRisk,
        RADashboardCardId.FactorWaterfallRisk,
        RADashboardCardId.FactorBreakdownRisk
      ]
    },
    [RADashboardTabId.Holdings]: {
      "cardsOrder": [
        RADashboardCardId.HoldingsTopBottom,
        RADashboardCardId.HoldingsRiskVisualization,
        RADashboardCardId.HoldingsContributionRisk
      ]
    }
  },
  "tabSettings": {
    [RADashboardTabId.Overview]: {
      "label": "Overview"
    },
    [RADashboardTabId.FactorLens]: {
      "label": "Factor Lens"
    },
    [RADashboardTabId.Holdings]: {
      "label": "Holdings"
    }
  },
  "cardSettings": {
    [RADashboardCardId.MetricsSummaryRisk]: { size: 'S' },
    [RADashboardCardId.Point_TrailingRisk]: { size: 'S' },
    [RADashboardCardId.Point_DV01]: { size: 'XS' },
    [RADashboardCardId.Point_SpreadDuration]: { size: 'XS' },
    [RADashboardCardId.Point_Beta]: { size: 'XS' },
    [RADashboardCardId.HoldingsTopBottom]: { size: 'M' },
    [RADashboardCardId.HoldingsRiskVisualization]: { size: 'M' },
    [RADashboardCardId.HoldingsContributionRisk]: { size: 'M' },
    [RADashboardCardId.FactorLensGridRisk]: {size: 'XW'},
    [RADashboardCardId.FactorWaterfallRisk]: {size: 'XW'},
    [RADashboardCardId.FactorBreakdownRisk]: {size: 'XW'}
  }
}

export default DefaultMasterDashboardLayout;